import createTransactionsAPI from "@/helpers/rtk_transactions_resource_factory";
import { getCurrentUser } from "@/helpers/session_helper";

const baseURL = process.env.REACT_APP_GLOBO_API + '/transactions/prescriptionRequests';
const type = "PrescriptionRequests";
const currentUser = getCurrentUser()

export const prescriptionRequestsAPI = createTransactionsAPI({
  baseURL: baseURL,
  resource: "PrescriptionRequests",
  tagTypes: ["PrescriptionRequests"],
  idKey: "prescriptionRequestId",
  lookupMap: ({ prescriptionRequestId, referenceNo }) => ({
    value: prescriptionRequestId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListPrescriptionRequestsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),
    getFilesPrescriptionRequests: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions, builder) => ({
    submitPrescriptionRequests: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnPrescriptionRequests: mutation(`${baseURL}/return`, mutationOptions("save")),
    approvePrescriptionRequests: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectPrescriptionRequests: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelPrescriptionRequests: mutation(`${baseURL}/cancel`, mutationOptions("save")),
    filesUploadPrescriptionRequests: mutation(`${baseURL}/files/upload`),
    filesDeletePrescriptionRequests: mutation(`${baseURL}/files/delete`),
    exportListForViewerPrescriptionRequests: builder.mutation({
      query: (params) => ({
        url: `${baseURL}/exportListForViewer`,
        method: "POST",
        body: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser.token}`,
        },
      }),
      async onQueryStarted(params, { queryFulfilled }) {
        try {
          const response = await fetch(`${baseURL}/exportListForViewer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${currentUser.token}`,
            },
            body: JSON.stringify(params),
          });

          if (!response.ok) throw new Error("Export failed");

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `PrescriptionRequests-Viewer-${new Date().toISOString().split("T")[0]}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          await queryFulfilled.catch(() => { });
        } catch (err) {
          console.error("Export failed:", err);
          throw err;
        }
      },
    }),
  }),
});

export const {
  useGetPrescriptionRequestsQuery,
  useGetListPrescriptionRequestsForViewersQuery,
  useExportPrescriptionRequestsMutation,
  useFindPrescriptionRequestsQuery,
  useLookUpPrescriptionRequestsMutation,
  useSavePrescriptionRequestsMutation,
  useSubmitPrescriptionRequestsMutation,
  useReturnPrescriptionRequestsMutation,
  useApprovePrescriptionRequestsMutation,
  useRejectPrescriptionRequestsMutation,
  useCancelPrescriptionRequestsMutation,
  useDeletePrescriptionRequestsMutation,
  useFilesUploadPrescriptionRequestsMutation,
  useFilesDeletePrescriptionRequestsMutation,
  useGetFilesPrescriptionRequestsQuery,
  useExportListForViewerPrescriptionRequestsMutation
} = prescriptionRequestsAPI;
